import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { configure_getting_started_progress } from "../../../actions/globalAction";
import "./content.scss";
import { Link } from "react-router-dom";
import { Dimmer, Loader } from "semantic-ui-react";
import { ReactComponent as ResponseIcon } from "../../../assets/svg/smr-icon.svg";
import { setActiveModule } from "../../../actions/sideBarActions";

const SMRInbox = () => {
    const dispatch = useDispatch();
    // useEffect(() => {
    //     let obj = {
    //         // total_sections: 33,
    //         progress_config: {
    //             smr_inbox: 1,
    //         },
    //     };

    //     dispatch(configure_getting_started_progress(obj));
    // }, []);
    const configureProgress = () => {
        let obj = {
            // total_sections: 33,
            progress_config: {
                smr_inbox: 1,
            },
        };
        localStorage.setItem("activeModule", "Response");
        dispatch(setActiveModule("Response"));
        dispatch(configure_getting_started_progress(obj));
    };
    return (
        <>
            <div className="gs_content">
                <div className="left_content">
                    <div className="gs_header">
                        {/* <Icon name="user" size="large" className="icon_content" color="#268af6" width="20px" height="20px" /> */}
                        <ResponseIcon className="icon_content fill_svg" />
                        <span className="content_title">Response Inbox</span>
                    </div>
                    <div className="text_content">
                        <p>{`This section contains all inbound messages that your agents need to respond to, fetched from various social profiles that you have connected.`}</p>
                        <p>You can perform various activities from this section like responding to a message, assigning tickets to agents.</p>
                        <p>Advanced filters are available to identify messages that need a quick response.</p>

                        {/* <p>{`Some of the reports and other functionality use your time zone to work properly.  You can control your time zone from here.`}</p> */}
                    </div>
                    <Link to="/social-response/inbox">
                        <button className="gs_link" onClick={() => configureProgress()}>
                            Explore
                        </button>
                    </Link>
                </div>
                <div className="right_content">
                    <div id="gs_loader">
                        <Dimmer inverted active>
                            <Loader size="big skiptranslate">Loading</Loader>
                        </Dimmer>
                    </div>
                    <iframe
                        width="320px"
                        height="200px"
                        src="https://www.youtube.com/embed/PNUq0s2qejI"
                        title=""
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; gyroscope; picture-in-picture"
                        allowFullScreen
                        onLoad={() => (document.getElementById("gs_loader").style.display = "none")}
                        className="content_video"></iframe>
                    {/* <img className="content-img" src={profileImg} width="350px" height="200px" /> */}
                </div>
            </div>
        </>
    );
};

export default SMRInbox;
